import { API, Auth } from 'aws-amplify'
import axios from 'axios'
import pathToData from '../utils/getDataPath'
import sortData from '../utils/SortData'

const stage = process.env.REACT_APP_STAGE
const apiName = 'API'
const init = (user, queryStringParameters = {}) => ({ // OPTIONAL
  headers: {
    'Content-Type': 'application/json',
    Authorization: user.idToken.jwtToken,
    accessToken: user.accessToken.jwtToken,
  }, // OPTIONAL
  response: true, // OPTIONAL
  queryStringParameters,
})
const MAX_RETRY = 5

const BasePath = `/${stage}/powerplants`
const get = async (path, sort = true, count = 0) => {
  if (count === MAX_RETRY) return {}
  let user
  try {
    user = await Auth.currentSession()
  } catch (error) {
    return get(path, count + 1)
  }
  if (!user) {
    return {}
  }
  try {
    const { data } = await API.get(
      apiName,
      path,
      init(user),
    )
    return sort ? sortData(data) : data
  } catch (e) {
    return get(path, count + 1)
  }
}

const getPowerplants = async () => {
  const { accessToken: { payload } } = await Auth.currentSession();
  const { data: powerplants } = await axios.get('https://lyemdmo7ub.execute-api.us-east-1.amazonaws.com/Prod/production');
  const { data: userData } = await axios.get(`https://3z7fxc2l2h.execute-api.us-east-1.amazonaws.com/Prod/users/${payload.username}`);
  const userCentralIds = userData.centralIds;

  const filteredPowerplants = powerplants.filter(({ id }) => {
    return userCentralIds.includes(id);
  });

  return filteredPowerplants;
}

const getPowerplant = async function getPowerplantFromTheApi(id) {
  const path = `${BasePath}/${id}`
  return get(path, false)
}

const getPowerplantData = async function getPowerplantDataFromTheApi(id, params) {
  const path = pathToData(BasePath, id, params)
  return get(path)
}
const deletePowerplantItem = async function deletePowerplantItemMonth({ pkey, skey }) {
  const user = await Auth.currentSession()
  if (!user) return {}
  const id = pkey.split('powerplant-')[1]
  const [type, resolution, year, month, day] = skey.split('-')
  const response = await API.del(
    apiName,
    `${BasePath}/${id}/${skey.split('-').join('/')}`,
    {
      id,
      type,
      resolution,
      year,
      month,
      day,
      ...init(user),
    },
  )
  return response
}
const postCleaning = async function postCleaningDataToTheApi(centralId, start, end) {
  if (!start || !end) return {}
  if (end.isBefore(start)) return {}
  const [year, month, day] = start.toArray().map((i, index) => `${index === 1 ? i + 1 : i}`.padStart(2, '0'))
  const item = {
    id: centralId,
    pkey: `powerplant-${centralId}`,
    skey: `cleaning-day-${year}-${month}-${day}`,
    type: 'cleaning',
    resolution: 'day',
    data: {
      start: start.toJSON().split('T')[0],
      end: end.toJSON().split('T')[0],
    },
    year,
    month,
    day,
  }
  const path = `/${stage}/powerplants/${centralId}/cleaning/day/${year}/${month}/${day}`
  const response = await API.post(
    apiName,
    path,
    { body: item },
  )
  return response
}

export {
  getPowerplants, getPowerplant, getPowerplantData, postCleaning,
  deletePowerplantItem,
}
export default getPowerplants
